module.exports = __webpack_public_path__ + "static/media/prestashop-logo.dc1918e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/prestashop-logo.svg
// module id = 614
// module chunks = 0